import { DATA_PIPELINE_ORCHESTRATOR } from '@/utils/service-providers';
import {
  AutomatchTemplatesRequest,
  OrgSubmissionsRequest,
  SchemeOrgsRequest
} from './types';

export const GET_SUBMISSION_REQUEST = (
  requestParams: OrgSubmissionsRequest,
  include?: string
) => {
  const params = new URLSearchParams();
  params.set('page', requestParams.page?.toString());
  params.set('limit', requestParams.limit?.toString());
  if (include) {
    params.set('include', include);
  }
  if (requestParams.status) {
    params.set('status', requestParams.status);
  }

  params.set('sort', 'pendingRequests,due_date');

  if (requestParams.searchKeyword) {
    params.set('filter[generic_search]', requestParams.searchKeyword);
  }
  if (requestParams.clientIds) {
    requestParams.clientIds?.forEach(it => {
      params.append('filter[client_id][]', it);
    });
  }

  if (requestParams.requestType) {
    params.set('requestType', requestParams.requestType);
  }

  if (requestParams.dueDateMonth) {
    params.set('filter[dueDateMonth]', requestParams?.dueDateMonth?.toString());
  }

  if (requestParams.startDueDate) {
    params.set('filter[startDueDate]', requestParams?.startDueDate);
  }

  if (requestParams.endDueDate) {
    params.set('filter[endDueDate]', requestParams?.endDueDate);
  }

  if (requestParams.parentFundNature) {
    params.set('filter[parentFundNature]', requestParams?.parentFundNature);
  }

  if (requestParams.timePeriodId) {
    params.set('filter[timePeriodId]', requestParams?.timePeriodId);
  }

  if (requestParams.investmentEntityPathContains) {
    params.set(
      'filter[investmentEntityPathContains]',
      requestParams?.investmentEntityPathContains
    );
  }

  return (
    `base/submission-requests/${requestParams.orgId}?` + `${params?.toString()}`
  );
};

export const AUTOMATCH_TEMPLATES = (
  requestParams: AutomatchTemplatesRequest,
  include?: string
) => {
  const params = new URLSearchParams();
  if (include) {
    params.set('include', include);
  }
  return (
    `/base/submission-requests/${requestParams.orgId}/match?` +
    `${params?.toString()}`
  );
};

export const EXTRACT_TEMPLATE_CONTEXT = `${DATA_PIPELINE_ORCHESTRATOR}/template-context/extract`;

export const GET_ORGANIZATION_CLIENTS = (
  orgId: string,
  page: number = 1,
  limit: number = 15
) => {
  return (
    `/base/organizations/${orgId}/pension-scheme?&page=${page}&limit=${limit}` +
    `&include=entity,entity.organizationType,timePeriod,managers`
  );
};

export const GET_SCHEME_ORGS = (reqParams: SchemeOrgsRequest) => {
  const params = new URLSearchParams();
  if (reqParams?.page) {
    params.set('page', reqParams.page.toString());
  }
  if (reqParams?.limit) {
    params.set('limit', reqParams.limit.toString());
  }
  if (reqParams?.searchKeyword) {
    params.set('filter[name]', reqParams.searchKeyword);
  }

  return (
    `/base/organizations/${reqParams.orgId}/pension-scheme/organizations?` +
    `${params.toString()}`
  );
};

export const DOWNLOAD_AUTHORIZATION_LETTER = (submissionRequestId: string) => {
  return `/base/submission-requests/${submissionRequestId}/authorization-letter/download`;
};

export const DOWNLOAD_SUBMISSION_REQUESTS = (organizationId: string) => {
  return `/base/submission-requests/${organizationId}/download`;
};

export const FETCH_SUBMISSION_REQUESTS_URL = (jobId: string) => {
  return `/base/submission-requests/${jobId}/download`;
};
